module.exports = __webpack_public_path__ + "img/christian_tour.06b8a4ac.png";